import type { ReactNode } from "react";
import GTMEventLink from "~/components/ui/GTMEventLink";
import { GtmEvent } from "~/lib/gtm/getGtmEventData";
import { cn } from "~/lib/utils";

export interface IMenuItem {
    text: string;
    href: string;
    icon?: ReactNode;
    handleClick?: () => void;
    gtmEventData?: GtmEvent;
    containerClassName?: string;
    megaMenuChildren?: ReactNode;
    className?: string;
    target?: "_blank" | "_top";
}

const MenuItem = ({ text, icon = null, className, ...props }: IMenuItem) => {
    return (
        <GTMEventLink
            {...props}
            className={cn("font-suisseBP text-[16px] leading-[60px] font-normal capitalize text-trueBlack hover:text-primary400 transition-all duration-200 ease-in-out block px-5 pt-[2px]", className)}
        >{icon}{text}</GTMEventLink>
    );
};

export default MenuItem;
